import { Column, Entity, Index } from 'typeorm';
import { BaseEntity } from './base.entity';

@Index('month_pk', ['year', 'month'], { unique: true })
@Entity('month')
export class MonthEntity extends BaseEntity {
	@Column('int', { name: 'year' })
	public year!: number;

	@Column('int', { name: 'month' })
	public month!: number;

	@Column('int', { name: 'businessDays', nullable: true })
	public businessDays!: number | null;
}
